import { render, staticRenderFns } from "./SelectrepairType.vue?vue&type=template&id=542f1581&scoped=true"
import script from "./SelectrepairType.vue?vue&type=script&lang=js"
export * from "./SelectrepairType.vue?vue&type=script&lang=js"
import style0 from "./SelectrepairType.vue?vue&type=style&index=0&id=542f1581&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f1581",
  null
  
)

export default component.exports